import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { dispatchOrderParam } from "features/stock-ordering/core/stock-ordering.params";
import {
  stockDispatchOrdersResponse,
  stockDispatchOrdersRepository,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum StockDispatchOrdersState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: StockDispatchOrdersState;
  message: string;
}

const initialState: InitialState = {
  status: StockDispatchOrdersState.initial,
  message: "",
};

export const stockDispatchOrders = createAsyncThunk(
  "stockDispatchOrders",
  async (param: dispatchOrderParam, { rejectWithValue }) => {
    try {
      const response: stockDispatchOrdersResponse =
        await stockDispatchOrdersRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const stockDispatchOrdersSlice = createSlice({
  name: "stockDispatchOrders",
  initialState,
  reducers: {
    resetstockDispatchOrders: (state) => {
      state.status = StockDispatchOrdersState.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(stockDispatchOrders.pending, (state) => {
        state.status = StockDispatchOrdersState.inProgress;
      })
      .addCase(stockDispatchOrders.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = StockDispatchOrdersState.success;
          state.message = message;
        }
      })
      .addCase(stockDispatchOrders.rejected, (state, action) => {
        state.status = StockDispatchOrdersState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectStockDispatchOrders = (state: RootState) =>
  state.stockDispatchOrders;

export const { resetstockDispatchOrders } = stockDispatchOrdersSlice.actions;
export default stockDispatchOrdersSlice.reducer;
